import script from "./excel.vue?vue&type=script&setup=true&lang=js"
export * from "./excel.vue?vue&type=script&setup=true&lang=js"

import "./excel.vue?vue&type=style&index=0&id=0dc7cb8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dc7cb8f"]])

export default __exports__